import React, { Component } from "react";
import { connect } from "react-redux";
import styles from "./BalanceUpload.local.scss";
import { Select, Tooltip } from "antd";
import { IconContext } from "react-icons";
import { TiWarningOutline } from "react-icons/ti";
import {
  BALANCE_CONFIG,
  BALANCE_MODELS_CONFIG,
  BALANCE_MONTHS,
  SELECT_TRIMESTRE
} from "Config";
import {
  setSourceModel,
  setModelConfig,
  setBalanceAttachment,
  selectFirstMonth,
  selectLastMonth,
  selectOneMonth,
  selectFirstTrimester,
  selectLastTrimester,
  setMultipleModelConfig
} from "Actions";
import DocumentUploader from "../Common/DocumentUploader/DocumentUploader";
import _ from "i18n";

const { Option } = Select;

class BalanceModels extends Component {
  // **** BalanceModels (functions) ***** //
  constructor(props) {
    super(props);
    this.state = {
      ERP: Object.keys(BALANCE_CONFIG)[0]
      // model: BALANCE_CONFIG[Object.keys(BALANCE_CONFIG)[0]][0].value
    };
  }

  initModelConfig = (ERP, sourceModel) => {
    if (!sourceModel) {
      this.props.dispatch(setSourceModel(BALANCE_CONFIG[ERP][0].value));
      this.handleModelConfigChange(BALANCE_CONFIG[ERP][0].value);
    }
  };

  handleModelConfigChange = sourceModel => {
    const { accountingDates } = this.props;
    let years = BALANCE_MODELS_CONFIG[sourceModel].years,
      modelConfig = [];
    // modelConfig = {
    //   years: [],
    //   months: []
    // };

    if (sourceModel === "kluwer_compared_model") {
      for (let i = 0; i < accountingDates.length; i++) {
        modelConfig.push(accountingDates[i].year);
      }
    } else if (years <= accountingDates.length) {
      for (let i = 0; i < years; i++) {
        modelConfig.push(accountingDates[i].year);
      }
    }
    this.props.dispatch(setModelConfig(modelConfig));
  };

  handleERPChange = value => {
    const { dispatch } = this.props;
    this.setState({
      ERP: value
    });
    dispatch(setSourceModel(BALANCE_CONFIG[value][0].value));
    this.handleModelConfigChange(BALANCE_CONFIG[value][0].value);
    dispatch(setBalanceAttachment(null));
  };

  onModelChange = value => {
    const { dispatch } = this.props;
    dispatch(setSourceModel(value));
    this.handleModelConfigChange(value);
    dispatch(setBalanceAttachment(null));
  };

  // handleExerciseChange = (e, index, modelConfig) => {
  //   let exercises = [...modelConfig];
  //   exercises[index] = e;
  //   this.props.dispatch(setModelConfig(exercises));
  // };
  handleExerciseChange = (e, index, modelConfig) => {
    let exercises = [...modelConfig];
    exercises[index] = e;
    // let config = {
    //   years: exercises,
    //   months: [...modelConfig.months]
    // };
    this.props.dispatch(setModelConfig(exercises));
  };

  handleSelectOneMonth = month => {
    this.props.dispatch(selectOneMonth(month));
    const { modelConfig } = this.props;
    let Months = [];
    let years = [...modelConfig.years];
    // eslint-disable-next-line array-callback-return
    BALANCE_MONTHS.map((item, i) => {
      if (item.label === month) {
        Months.push(item.value);
      }
    });
    let config = {
      years: years,
      months: Months
    };
    this.props.dispatch(setModelConfig(config));
  };

  handleFirstTrimesterChange = trimester => {
    this.props.dispatch(selectFirstTrimester(trimester));
    this.props.dispatch(selectLastTrimester(trimester));
    // const { modelConfig, lastTrimester } = this.props;
    // let trimesters = [];
    // let years = [...modelConfig.years];
    //
    // SELECT_TRIMESTRE.map((item, i) => {
    //   if (item.value >= trimester && item.value <= lastTrimester) {
    //     trimesters.push(item.value);
    //   }
    // });
    // let config = {
    //   years: years,
    //   months: [],
    //   trimesters: trimesters
    // };
    // this.props.dispatch(setModelConfig(config));
  };
  handleLastTrimesterChange = trimester => {
    this.props.dispatch(selectLastTrimester(trimester));
    // const { modelConfig, firstTrimester } = this.props;
    // let trimesters = [];
    // let years = [...modelConfig.years];
    //
    // SELECT_TRIMESTRE.map((item, i) => {
    //   if (item.value >= firstTrimester && item.value <= trimester) {
    //     trimesters.push(item.label);
    //   }
    // });
    // let config = {
    //   years: years,
    //   months: [],
    //   trimesters: trimesters
    // };
    // this.props.dispatch(setModelConfig(config));
  };
  handleFirstMonthChange = month => {
    this.props.dispatch(selectFirstMonth(month));
    this.props.dispatch(selectLastMonth(month));
    const { modelConfig, lastMonth } = this.props;
    let Months = [];
    let years = [...modelConfig.years];
    let lastMonthValue = null;
    let firstMonthValue = null;
    // eslint-disable-next-line array-callback-return
    BALANCE_MONTHS.map((item, i) => {
      if (item.label === month) {
        firstMonthValue = item.value;
      }
      if (item.label === lastMonth) {
        lastMonthValue = item.value;
      }
    });
    // eslint-disable-next-line array-callback-return
    BALANCE_MONTHS.map((item, i) => {
      if (item.value >= firstMonthValue && item.value <= lastMonthValue) {
        Months.push(item.value);
      }
    });
    let config = {
      years: years,
      months: Months
    };
    this.props.dispatch(setModelConfig(config));
  };
  handleLastMonthChange = month => {
    this.props.dispatch(selectLastMonth(month));
    const { modelConfig, firstMonth } = this.props;
    let lastMonths = [];
    let years = [...modelConfig.years];
    let lastMonthValue = null;
    let firstMonthValue = null;
    // eslint-disable-next-line array-callback-return
    BALANCE_MONTHS.map((item, i) => {
      if (item.label === firstMonth) {
        firstMonthValue = item.value;
      }
      if (item.label === month) {
        lastMonthValue = item.value;
      }
    });
    // eslint-disable-next-line array-callback-return
    BALANCE_MONTHS.map((item, i) => {
      if (item.value >= firstMonthValue && item.value <= lastMonthValue) {
        lastMonths.push(item.value);
      }
    });
    let config = {
      years: years,
      months: lastMonths
    };
    this.props.dispatch(setModelConfig(config));
  };
  handleDrop = acceptedFiles => {
    const { accountingDates, dispatch } = this.props;
    let multipleModelConfig = [];
    if (acceptedFiles.length === 0) return;
    acceptedFiles.map((file, index) => {
      let year = this.getYearOfDocument(file.name);
      file.year = year ? year : accountingDates[index].year;
      file.id = index;
      multipleModelConfig.push(file.year);
      return file;
    });
    dispatch(setBalanceAttachment(acceptedFiles));
    dispatch(setMultipleModelConfig(multipleModelConfig));
  };

  // **** BalanceModels (functions) END ***** //

  // **** BalanceModels  (render) ***** //

  renderModelExercises = (accountingDates, modelConfig) => {
    let exercises = [];
    let indexMonth = null;
    let indexTrimester = null;
    BALANCE_MONTHS.map((item, i) => {
      if (item.label === this.props.firstMonth) {
        indexMonth = item.value;
      }
    });
    SELECT_TRIMESTRE.map((item, i) => {
      if (item.label === this.props.firstTrimester) {
        indexTrimester = item.value;
      }
    });
    // if (modelConfig.length === 0) {
    //   return this.renderModelExercisesNotAvailable();
    // }
    if (
      this.props.sourceModel === "kluwer_model_mensuel" ||
      this.props.sourceModel === "winbooks_model_mensuel"
    ) {
      exercises.push(
        <span>
          <div className={`row`}>
            <span
              className={`columns medium-6 ${styles.accounting_span}`}
              key={"exercice" + 1}
            >
              <label>
                {_("yearOfExercise")} {1}:
              </label>
              <Select
                value={modelConfig[0]}
                style={{ width: 130 }}
                onChange={e => this.handleExerciseChange(e, 0, modelConfig)}
              >
                {accountingDates &&
                  // eslint-disable-next-line array-callback-return
                  accountingDates.map((item, j) => {
                    if (
                      accountingDates[j].year === modelConfig[0] ||
                      !modelConfig.includes(accountingDates[j].year)
                    ) {
                      return (
                        <Option
                          value={accountingDates[j].year}
                          key={accountingDates[j].year}
                        >
                          {accountingDates[j].year}
                        </Option>
                      );
                    }
                  })}
              </Select>
            </span>
          </div>
          <label>{"Select period :"}</label>

          <div className={"row"}>
            <span
              className={`columns large-6 medium-6 small-6 ${
                styles.accounting_span
              }`}
              key={"exercice" + 1}
            >
              <label>{"De :"}</label>
              <Select
                value={this.props.firstMonth}
                style={{ width: 130 }}
                onChange={e => this.handleFirstMonthChange(e)}
              >
                {BALANCE_MONTHS &&
                  BALANCE_MONTHS.map((item, j) => {
                    return (
                      <Option value={item.label} key={item.value}>
                        {item.label}
                      </Option>
                    );
                  })}
              </Select>
            </span>
            <span
              className={`columns large-6 medium-6 small-6 ${
                styles.accounting_span
              }`}
              key={"exercice" + 1}
            >
              <label>{"à :"}</label>
              <Select
                value={this.props.lastMonth}
                style={{ width: 130 }}
                onChange={e => this.handleLastMonthChange(e)}
              >
                {BALANCE_MONTHS &&
                  BALANCE_MONTHS.map((item, j) => {
                    if (item.value >= indexMonth) {
                      return (
                        <Option value={item.label} key={item.value}>
                          {item.label}
                        </Option>
                      );
                    }
                  })}
              </Select>
            </span>
          </div>
        </span>
      );
    } else if (
      this.props.sourceModel === "kluwer_trimester_model" ||
      this.props.sourceModel === "winbooks_model_trimestriel"
    ) {
      exercises.push(
        <div key={"exercice_conf"} style={{ marginLeft: 50 }}>
          <div className={"row"}>
            <span className={`columns medium-12 ${styles.accounting_span}`}>
              <label>
                {_("yearOfExercise")} {1}:
              </label>
              <Select
                value={modelConfig[0]}
                // style={{ width: 130 }}
                className={styles.accounting_span__select}
                onChange={e => this.handleExerciseChange(e, 0, modelConfig)}
              >
                {accountingDates &&
                  accountingDates.map((item, j) => {
                    if (
                      accountingDates[j].year === modelConfig[0] ||
                      !modelConfig.includes(accountingDates[j].year)
                    ) {
                      return (
                        <Option
                          value={accountingDates[j].year}
                          key={accountingDates[j].year}
                        >
                          {accountingDates[j].year}
                        </Option>
                      );
                    }
                  })}
              </Select>
            </span>
          </div>
          {/*<div className={"row"}>*/}
          {/*  <span className={`columns medium-12 ${styles.accounting_span}`}>*/}
          {/*    <label>{"Select period :"}</label>*/}
          {/*  </span>*/}
          {/*</div>*/}
          <div className={"row"}>
            <span
              className={`columns large-6 medium-6 small-6 ${
                styles.accounting_span
              }`}
            >
              <label>{"De :"}</label>
              <Select
                value={this.props.firstTrimester}
                // style={{ width: 130 }}
                className={styles.accounting_span__select}
                onChange={e => this.handleFirstTrimesterChange(e)}
              >
                {SELECT_TRIMESTRE &&
                  SELECT_TRIMESTRE.map((item, j) => {
                    return (
                      <Option value={item.value} key={item.value}>
                        {item.label}
                      </Option>
                    );
                  })}
              </Select>
            </span>
            <span
              className={`columns large-6 medium-6 small-6 ${
                styles.accounting_span
              }`}
            >
              <label>{"à :"}</label>
              <Select
                value={this.props.lastTrimester}
                // style={{ width: 130 }}
                className={styles.accounting_span__select}
                onChange={e => this.handleLastTrimesterChange(e)}
              >
                {SELECT_TRIMESTRE &&
                  SELECT_TRIMESTRE.map((item, j) => {
                    if (item.value >= indexTrimester) {
                      return (
                        <Option value={item.value} key={item.value}>
                          {item.label}
                        </Option>
                      );
                    }
                  })}
              </Select>
            </span>
          </div>
        </div>
      );
    } else {
      for (let i = 0; i < modelConfig.length; i++) {
        exercises.push(
          <span
            className={`columns medium-4 ${styles.accounting_span}`}
            key={"exercice" + i}
          >
            <label>
              {_("yearOfExercise")} {i + 1}:
            </label>
            <Select
              value={modelConfig[i]}
              className={styles.accounting_span__select}
              onChange={e => this.handleExerciseChange(e, i, modelConfig)}
            >
              {accountingDates &&
                // eslint-disable-next-line array-callback-return
                accountingDates.map((item, j) => {
                  if (
                    accountingDates[j].year === modelConfig[i] ||
                    !modelConfig.includes(accountingDates[j].year)
                  ) {
                    return (
                      <Option
                        value={accountingDates[j].year}
                        key={accountingDates[j].year}
                      >
                        {accountingDates[j].year}
                      </Option>
                    );
                  }
                })}
              {/*{sourceModel === "kluwer_compared_model" && (*/}
              {/*  <Option value={"none"} key={"none"}>*/}
              {/*    {_("none")}*/}
              {/*  </Option>*/}
              {/*)}*/}
            </Select>
          </span>
        );
      }
    }

    return exercises;
  };

  renderModelExercisesNotAvailable = () => {
    return (
      <div
        data-closable
        className={"callout alert-callout-border warning radius"}
        style={{ fontSize: 12, padding: 14 }}
      >
        <strong>
          <IconContext.Provider
            value={{
              style: {
                verticalAlign: "sub",
                marginRight: "0.3rem",
                fontSize: "15px"
              }
            }}
          >
            <TiWarningOutline />
          </IconContext.Provider>
          {_("caution")}
        </strong>{" "}
        {_("moreExercicesRequired")}
        <button
          className="close-button"
          aria-label="Dismiss alert"
          type="button"
          data-close
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    );
  };

  handleYearChange = (value, id) => {
    let { attachment, dispatch } = this.props;
    let multipleModelConfig = [];
    attachment.map(item => {
      if (item.id === id) {
        item.year = value;
      }
      multipleModelConfig.push(item.year);
      return item;
    });
    dispatch(setBalanceAttachment(attachment));
    dispatch(setMultipleModelConfig(multipleModelConfig));
    this.setState({ state: this.state });
  };
  // **** BalanceModels  (render) END ***** //

  getYearOfDocument = name => {
    let index = name.indexOf("20");
    let year = Math.abs(name.substring(index, index + 4));
    if (isNaN(year)) return null;
    return year;
  };

  render() {
    const { ERP } = this.state;
    const {
      sourceModel,
      accountingDates,
      modelConfig,
      attachment
    } = this.props;

    this.initModelConfig(ERP, sourceModel);
    return (
      <div className="row">
        <span className={`columns medium-12 ${styles.slide_title}`}>
          <h6>
            <b>{_("importCustomerBalance")} :</b>
          </h6>
        </span>
        <span className={`columns medium-6 ${styles.accounting_span}`}>
          <label className={styles.accounting_span__label_for_medium_6}>
            {_("chooseERP")}:
          </label>
          <Select
            defaultValue={ERP}
            className={styles.accounting_span__select}
            onChange={this.handleERPChange}
          >
            {Object.keys(BALANCE_CONFIG).map((item, i) => {
              return (
                <Option value={item} key={i}>
                  {item}
                </Option>
              );
            })}
          </Select>
        </span>
        <span className={`columns medium-6 ${styles.accounting_span}`}>
          <label className={styles.accounting_span__label_for_medium_6}>
            {_("chooseModel")}:
          </label>
          <Select
            value={sourceModel}
            className={styles.accounting_span__select}
            onChange={this.onModelChange}
          >
            {BALANCE_CONFIG[ERP].map((item, i) => {
              return (
                <Option value={item.value} key={i}>
                  {item.label}
                </Option>
              );
            })}
          </Select>
        </span>
        <span className={`columns medium-12`}>
          <div className={styles.model_description}>
            <p>
              <b>{_("descriptionExercisesModel")} :</b>
            </p>
            <p>
              {sourceModel && BALANCE_MODELS_CONFIG[sourceModel].description}
            </p>
          </div>
        </span>
        <span className={`columns medium-12 ${styles.model_exercises__span}`}>
          <div className={`row ${styles.model_exercises__div}`}>
            {this.renderModelExercises(accountingDates, modelConfig)}
          </div>
        </span>
        {attachment &&
          attachment.length > 0 &&
          BALANCE_MODELS_CONFIG[sourceModel].years === 0 && (
            <span className={`columns medium-12`}>
              <table
                style={{
                  margin: "auto auto 1rem auto"
                }}
              >
                <thead key={"thead"} style={{ backgroundColor: "#f3fafe" }}>
                  <tr>
                    <th width={0}>{_("fileName")}</th>
                    <th width={0}>{_("exercise")}</th>
                  </tr>
                </thead>

                <tbody key={"tbody"}>
                  {attachment &&
                    attachment.map((item, i) => {
                      return (
                        <tr key={item.id}>
                          <td align="left" width={300}>
                            {item.name && item.name.length > 35 ? (
                              <Tooltip placement="top" title={item.name}>
                                <span>
                                  {item.name && item.name.substring(0, 35)}
                                  {"..."}
                                </span>
                              </Tooltip>
                            ) : (
                              item.name
                            )}
                          </td>
                          <td align="left" width={0}>
                            <Select
                              defaultValue={item.year}
                              //   value={item.year}
                              onChange={value =>
                                this.handleYearChange(value, item.id)
                              }
                            >
                              {accountingDates &&
                                accountingDates.map((date, i) => {
                                  return (
                                    <Option value={date.year} key={i}>
                                      {date.year}
                                    </Option>
                                  );
                                })}
                            </Select>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </span>
          )}
        <span className={"columns medium-12"}>
          <DocumentUploader
            attachment={attachment}
            handleDrop={this.handleDrop}
            acceptedFiles=".xls,text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            sourceModel={sourceModel}
          />
          {/*</span>*/}
          {/*<span className={`columns medium-12 ${styles.model_exercises__btn}`}>*/}
          {/*  <Button*/}
          {/*    key="submit"*/}
          {/*    type="primary"*/}
          {/*    loading={this.props.loadingBalance}*/}
          {/*    onClick={this.props.handleSaveBalance}*/}
          {/*    disabled={*/}
          {/*      this.props.modelConfig.years.length && this.props.attachment*/}
          {/*        ? false*/}
          {/*        : true*/}
          {/*    }*/}
          {/*  >*/}
          {/*    {_("Import balance")}*/}
          {/*  </Button>*/}
        </span>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  sourceModel: state.balance.sourceModel,
  modelConfig: state.balance.modelConfig,
  accountingDates: state.balance.accountingDates,
  attachment: state.balance.balanceAttachment,
  lastMonth: state.balance.mensuelConfig.lastMonth,
  firstMonth: state.balance.mensuelConfig.firstMonth,
  oneMonth: state.balance.mensuelConfig.oneMonth,
  firstTrimester: state.balance.trimesterConfig.firstTrimester,
  lastTrimester: state.balance.trimesterConfig.lastTrimester
});

export default connect(mapStateToProps)(BalanceModels);



// WEBPACK FOOTER //
// ./src/components/BalanceUpload/BalanceModels.js